import React, { Component } from "react";
import { connect } from "react-redux";
import { Card, Table, Input } from "antd";
import { usrRole } from "../../utils/dataUtil";
import { API_BASE } from "../../utils/contrains";
import {
  PAGE_SIZE,
  SORT_FIELD_NAME,
  SORT_UP_DOWN,
} from "../../utils/contrains";
import {
  req_page_ssp_stutents_now_all,
  req_downloadfile_ssp_stutents_now_all,
} from "../../api";

class StudentsNowInfoAll extends Component {
  state = {
    loading: false,
    deviceWidth: 0,
    userLevel: "NORMAL",
    item: {},
    // 分頁參數
    items: [],
    pagination: {
      current: 1,
      pageSize: PAGE_SIZE,
      total: 0,
    },
    columnSort: SORT_FIELD_NAME,
    orderBy: SORT_UP_DOWN,
    searchField: "NONE",
    searchValue: "",
    filterStatus: "NA", // INTERVAL/ERROR/YET/OVER
    colleges: [
      { label: "管理學院", value: "管理學院" },
      { label: "生活科技學院", value: "生活科技學院" },
      { label: "設計學院", value: "設計學院" },
      { label: "藝術學院", value: "藝術學院" },
      { label: "旅遊學院", value: "旅遊學院" },
    ],
    collegeName: "NONE",
    departs: [
      { value: "應用英語系", label: "應用英語系", group: "旅遊學院" },
      {
        value: "應用英語系國際旅遊組",
        label: "應用英語系國際旅遊組",
        group: "旅遊學院",
      },
      { value: "旅館管理系", label: "旅館管理系", group: "旅遊學院" },
      { value: "養生休閒管理系", label: "養生休閒管理系", group: "旅遊學院" },
      { value: "企業管理系", label: "企業管理系", group: "管理學院" },
      {
        value: "企業管理系廣告與數位行銷組",
        label: "企業管理系廣告與數位行銷組",
        group: "管理學院",
      },
      { value: "資訊管理系", label: "資訊管理系", group: "管理學院" },
      {
        value: "資訊管理系娛樂與網路應用組",
        label: "資訊管理系娛樂與網路應用組",
        group: "管理學院",
      },
      { value: "國際企業經營系", label: "國際企業經營系", group: "管理學院" },
      { value: "財務金融系", label: "財務金融系", group: "管理學院" },
      { value: "餐飲系", label: "餐飲系", group: "生活科技學院" },
      {
        value: "生活服務產業系",
        label: "生活服務產業系",
        group: "生活科技學院",
      },
      {
        value: "運動休閒與健康管理系",
        label: "運動休閒與健康管理系",
        group: "生活科技學院",
      },
      {
        value: "服飾設計管理系",
        label: "服飾設計管理系",
        group: "生活科技學院",
      },
      {
        value: "美容造型設計系",
        label: "美容造型設計系",
        group: "生活科技學院",
      },
      { value: "幼兒保育系", label: "幼兒保育系", group: "生活科技學院" },
      { value: "室內設計系", label: "室內設計系", group: "設計學院" },
      { value: "時尚設計系", label: "時尚設計系", group: "設計學院" },
      { value: "多媒體動畫系", label: "多媒體動畫系", group: "設計學院" },
      { value: "視覺傳達設計系", label: "視覺傳達設計系", group: "設計學院" },
      { value: "商品設計系", label: "商品設計系", group: "設計學院" },
      { value: "漫畫系", label: "漫畫系", group: "設計學院" },
      { value: "美術系", label: "美術系", group: "藝術學院" },
      { value: "音樂系", label: "音樂系", group: "藝術學院" },
      { value: "舞蹈系", label: "舞蹈系", group: "藝術學院" },
      { value: "流行音樂系", label: "流行音樂系", group: "藝術學院" },
    ],
    targetdepartlist: [],
    departName: "NONE",
    upstreamSchoolCityName: "NONE",
  };

  UNSAFE_componentWillMount() {
    this.init_columns();
  }

  componentDidMount() {
    this.api_page_items();
    this.setState({ item: this.props.item });
  }

  // 遠端數據處理 //////////////////////////////////////////////

  api_page_items = async (current) => {
    this.current = current; // 保存當前頁，給其他方法可看到
    const { pageSize } = this.state.pagination;
    const {
      columnSort,
      orderBy,
      searchField,
      searchValue,
      filterStatus,
      collegeName,
      departName,
      upstreamSchoolCityName,
    } = this.state;
    const { token, role, userCode } = this.props.user;
    var userLevel = usrRole(role);

    this.setState({ loading: true, userLevel: userLevel });
    const result = await req_page_ssp_stutents_now_all(
      userCode,
      userLevel,
      current,
      pageSize,
      columnSort,
      orderBy,
      searchField,
      searchValue,
      filterStatus,
      collegeName,
      departName,
      upstreamSchoolCityName,
      token
    );
    this.setState({ loading: false });
    if (result.total > 0) {
      const { total } = result;
      const items = result.data;
      const pagination = {
        current: this.current,
        pageSize: this.state.pagination.pageSize,
        total,
      };
      this.setState({ items, pagination });
      //console.log(items);
    } else {
      const items = [];
      const pagination = {
        current: 1,
        pageSize: this.state.pagination.pageSize,
        total: 0,
      };
      this.setState({ items, pagination });
    }
    this.setState({ loading: false });
  };

  api_downloadfile_items = async () => {
    const {
      userLevel,
      searchField,
      searchValue,
      filterStatus,
      collegeName,
      departName,
      upstreamSchoolCityName,
    } = this.state;
    const { token, userCode } = this.props.user;

    // download file data
    const fileUrl = await req_downloadfile_ssp_stutents_now_all(
      userCode,
      userLevel,
      searchField,
      searchValue,
      filterStatus,
      collegeName,
      departName,
      upstreamSchoolCityName,
      token
    );

    // download file link
    let a = document.createElement("a");
    a.href = API_BASE + fileUrl;
    a.target = "_blank";
    a.download = "清單";
    a.click();
  };

  api_list_target_depart = (value) => {
    const result = this.state.departs.filter(function (el) {
      return el.group === value;
    });
    const targetdepartlist = result.length > 0 ? result : [];
    this.setState({ targetdepartlist });
    //console.log("targetdepartlist:", targetdepartlist);
  };

  // 數據配置設定 //////////////////////////////////////////////

  init_columns = () => {
    this.columns = [
      {
        title: "入學年度",
        dataIndex: "EnrolledAcademicYear",
        width: 20,
        responsive: ["md"],
        align: "center",
        render(text, record) {
          var textColor = "#FFF";
          switch (record.CollegeName) {
            case "生活科技學院": //生活科技學院
              textColor = "#789017";
              break;
            case "管理學院": // 管理學院
              textColor = "#0061ae";
              break;
            case "設計學院": // 設計學院
              textColor = "#f08519";
              break;
            case "藝術學院": // 藝術學院
              textColor = "#e40082";
              break;
            case "旅遊學院": // 旅遊學院
              textColor = "#00706a";
              break;
            default:
              break;
          }
          return {
            props: {
              style: {
                color: textColor,
                fontWeight: 900,
              },
            },
            children: <div>{text}</div>,
          };
        },
      },
      {
        title: "學院",
        dataIndex: "CollegeName",
        width: 30,
        responsive: ["md"],
        align: "center",
        render(text, record) {
          var textColor = "#FFF";
          switch (record.CollegeName) {
            case "生活科技學院": //生活科技學院
              textColor = "#789017";
              break;
            case "管理學院": // 管理學院
              textColor = "#0061ae";
              break;
            case "設計學院": // 設計學院
              textColor = "#f08519";
              break;
            case "藝術學院": // 藝術學院
              textColor = "#e40082";
              break;
            case "旅遊學院": // 旅遊學院
              textColor = "#00706a";
              break;
            default:
              break;
          }
          return {
            props: {
              style: {
                color: textColor,
                fontWeight: 900,
              },
            },
            children: <div>{text}</div>,
          };
        },
      },
      {
        title: "學制",
        dataIndex: "SystemName",
        width: 20,
        responsive: ["md"],
        align: "center",
        render(text, record) {
          var textColor = "#FFF";
          switch (record.CollegeName) {
            case "生活科技學院": //生活科技學院
              textColor = "#789017";
              break;
            case "管理學院": // 管理學院
              textColor = "#0061ae";
              break;
            case "設計學院": // 設計學院
              textColor = "#f08519";
              break;
            case "藝術學院": // 藝術學院
              textColor = "#e40082";
              break;
            case "旅遊學院": // 旅遊學院
              textColor = "#00706a";
              break;
            default:
              break;
          }
          return {
            props: {
              style: {
                color: textColor,
                fontWeight: 900,
              },
            },
            children: <div>{text}</div>,
          };
        },
      },
      {
        title: "系所",
        dataIndex: "DepartName",
        align: "center",
        width: 40,
        render(text, record) {
          var textColor = "#FFF";
          switch (record.CollegeName) {
            case "生活科技學院": //生活科技學院
              textColor = "#789017";
              break;
            case "管理學院": // 管理學院
              textColor = "#0061ae";
              break;
            case "設計學院": // 設計學院
              textColor = "#f08519";
              break;
            case "藝術學院": // 藝術學院
              textColor = "#e40082";
              break;
            case "旅遊學院": // 旅遊學院
              textColor = "#00706a";
              break;
            default:
              break;
          }
          return {
            props: {
              style: {
                color: textColor,
                fontWeight: 900,
              },
            },
            children: <div>{text}</div>,
          };
        },
      },
      {
        title: "班級",
        dataIndex: "ClassName",
        responsive: ["md"],
        align: "center",
        width: 20,
        render(text, record) {
          var textColor = "#FFF";
          switch (record.CollegeName) {
            case "生活科技學院": //生活科技學院
              textColor = "#789017";
              break;
            case "管理學院": // 管理學院
              textColor = "#0061ae";
              break;
            case "設計學院": // 設計學院
              textColor = "#f08519";
              break;
            case "藝術學院": // 藝術學院
              textColor = "#e40082";
              break;
            case "旅遊學院": // 旅遊學院
              textColor = "#00706a";
              break;
            default:
              break;
          }
          return {
            props: {
              style: {
                color: textColor,
                fontWeight: 900,
              },
            },
            children: <div>{text}</div>,
          };
        },
      },
      {
        title: "姓名",
        dataIndex: "TwName",
        width: 20,
        align: "center",
        render(text, record) {
          var textColor = "#FFF";
          switch (record.CollegeName) {
            case "生活科技學院": //生活科技學院
              textColor = "#789017";
              break;
            case "管理學院": // 管理學院
              textColor = "#0061ae";
              break;
            case "設計學院": // 設計學院
              textColor = "#f08519";
              break;
            case "藝術學院": // 藝術學院
              textColor = "#e40082";
              break;
            case "旅遊學院": // 旅遊學院
              textColor = "#00706a";
              break;
            default:
              break;
          }
          return {
            props: {
              style: {
                color: textColor,
                fontWeight: 900,
              },
            },
            children: <div>{text}</div>,
          };
        },
      },
      {
        title: "國籍",
        dataIndex: "Country",
        width: 20,
        responsive: ["md"],
        align: "center",
        render(text, record) {
          var textColor = "#FFF";
          switch (record.CollegeName) {
            case "生活科技學院": //生活科技學院
              textColor = "#789017";
              break;
            case "管理學院": // 管理學院
              textColor = "#0061ae";
              break;
            case "設計學院": // 設計學院
              textColor = "#f08519";
              break;
            case "藝術學院": // 藝術學院
              textColor = "#e40082";
              break;
            case "旅遊學院": // 旅遊學院
              textColor = "#00706a";
              break;
            default:
              break;
          }
          return {
            props: {
              style: {
                color: textColor,
                fontWeight: 900,
              },
            },
            children: <div>{text}</div>,
          };
        },
      },
      {
        title: "生源縣市",
        dataIndex: "UpstreamSchoolCityName",
        width: 20,
        responsive: ["md"],
        align: "center",
        render(text, record) {
          var textColor = "#FFF";
          switch (record.CollegeName) {
            case "生活科技學院": //生活科技學院
              textColor = "#789017";
              break;
            case "管理學院": // 管理學院
              textColor = "#0061ae";
              break;
            case "設計學院": // 設計學院
              textColor = "#f08519";
              break;
            case "藝術學院": // 藝術學院
              textColor = "#e40082";
              break;
            case "旅遊學院": // 旅遊學院
              textColor = "#00706a";
              break;
            default:
              break;
          }
          return {
            props: {
              style: {
                color: textColor,
                fontWeight: 900,
              },
            },
            children: <div>{text}</div>,
          };
        },
      },
      {
        title: "生源學校",
        dataIndex: "UpstreamSchoolName",
        width: 35,
        align: "center",
        render(text, record) {
          var textColor = "#FFF";
          switch (record.CollegeName) {
            case "生活科技學院": //生活科技學院
              textColor = "#789017";
              break;
            case "管理學院": // 管理學院
              textColor = "#0061ae";
              break;
            case "設計學院": // 設計學院
              textColor = "#f08519";
              break;
            case "藝術學院": // 藝術學院
              textColor = "#e40082";
              break;
            case "旅遊學院": // 旅遊學院
              textColor = "#00706a";
              break;
            default:
              break;
          }
          return {
            props: {
              style: {
                color: textColor,
                fontWeight: 900,
              },
            },
            children: <div>{text}</div>,
          };
        },
      },
    ];
  };

  setTargetdeparts = (value) => {
    this.api_list_target_depart(value);
  };

  // 操作互動處理 //////////////////////////////////////////////

  handle_page_size_change = (current, size) => {
    //console.log(size)
    this.setState(
      {
        pagination: {
          current: current,
          pageSize: size,
        },
      },
      () => {
        this.api_page_items(current);
      }
    );
  };

  handle_table_change = (pagination, filters, sorter, extra) => {
    if (filters) {
      const status = [...Object.values(filters).filter(Boolean)][0];
      if (status) {
        this.setState({ filterStatus: status }, () => {
          this.api_page_items(pagination.current);
        });
      } else {
        this.setState({ filterStatus: "" }, () => {
          this.api_page_items(pagination.current);
        });
      }
    } else {
      this.api_page_items(pagination.current);
    }
  };

  handle_data_refresh = () => {
    this.api_page_items(this.current);
  };

  handleCollegeChange = (event) => {
    this.setState({
      collegeName: event.target.value,
      targetDepadepartNamertmentCode: "NONE",
    });
    this.setTargetdeparts(event.target.value);
    //console.log(value);
  };

  handleTargetdepartChange = (event) => {
    const value = event.target.value;
    this.setState({
      departName: value,
    });
  };

  handleCountyCityNameChange = (event) => {
    const value = event.target.value;
    this.setState({
      upstreamSchoolCityName: value,
    });
  };

  handleSelectChange = (event) => {
    const value = event.target.value;
    this.setState({
      searchField: value,
    });
  };

  handle_show_ui_modal = (modal, item) => {
    // console.log("handle_show_ui_modal");
    switch (modal) {
      case "download":
        this.api_downloadfile_items();

        break;
      default:
    }
  };

  /////////////////////////////////////////////////////////////
  render() {
    const {
      loading,
      items,
      pagination,
      searchField,
      searchValue,
      colleges,
      collegeName,
      targetdepartlist,
      departName,
      upstreamSchoolCityName,
    } = this.state;

    return (
      <Card>
        <>
          <select
            className="form-control"
            style={{ width: "160px", display: "inline-block" }}
            onChange={this.handleCollegeChange}
            value={collegeName}
          >
            <option key={"NONE"} value={"NONE"}>
              請選擇學院
            </option>
            {colleges.map((item) => (
              <option key={item.value} value={item.value}>
                {item.label}
              </option>
            ))}
          </select>
          <select
            className="form-control"
            style={{
              width: "180px",
              display: "inline-block",
            }}
            onChange={this.handleTargetdepartChange}
            value={departName}
          >
            <option key={"NONE"} value={"NONE"}>
              請選擇系所
            </option>
            {targetdepartlist.map((item) => (
              <option key={item.value} value={item.value}>
                {item.label}
              </option>
            ))}
          </select>
          <select
            className="form-control"
            style={{ width: "160px", display: "inline-block" }}
            onChange={this.handleCountyCityNameChange}
            value={upstreamSchoolCityName}
          >
            <option value="NONE" key="NONE">
              生源縣市
            </option>
            <option value="台北市" key="台北市">
              臺北市
            </option>
            <option value="新北市" key="新北市">
              新北市
            </option>
            <option value="基隆市" key="基隆市">
              基隆市
            </option>
            <option value="宜蘭縣" key="宜蘭縣">
              宜蘭縣
            </option>
            <option value="花蓮縣" key="花蓮縣">
              花蓮縣
            </option>
            <option value="台東縣" key="台東縣">
              臺東縣
            </option>
            <option value="桃園市" key="桃園市">
              桃園市
            </option>
            <option value="新竹市" key="新竹市">
              新竹市
            </option>
            <option value="新竹縣" key="新竹縣">
              新竹縣
            </option>
            <option value="苗栗縣" key="苗栗縣">
              苗栗縣
            </option>
            <option value="台中市" key="台中市">
              臺中市
            </option>
            <option value="彰化縣" key="彰化縣">
              彰化縣
            </option>
            <option value="南投縣" key="南投縣">
              南投縣
            </option>
            <option value="雲林縣" key="雲林縣">
              雲林縣
            </option>
            <option value="嘉義市" key="嘉義市">
              嘉義市
            </option>
            <option value="嘉義縣" key="嘉義縣">
              嘉義縣
            </option>
            <option value="台南市" key="台南市">
              臺南市
            </option>
            <option value="高雄市" key="高雄市">
              高雄市
            </option>
            <option value="屏東縣" key="屏東縣">
              屏東縣
            </option>
            <option value="金門縣" key="金門縣">
              金門縣
            </option>
            <option value="連江縣" key="連江縣">
              連江縣
            </option>
            <option value="澎湖縣" key="澎湖縣">
              澎湖縣
            </option>
          </select>
          <select
            className="form-control"
            style={{ width: "180px", display: "inline-block" }}
            onChange={this.handleSelectChange}
            value={searchField}
          >
            <option value="NONE">搜索條件</option>
            <option value="EnrolledAcademicYear">入學年度</option>
            <option value="UpstreamSchoolName">生源學校</option>
            <option value="TwName">學生姓名</option>
          </select>
          <Input
            placeholder="關鍵字"
            style={{
              width: 80,
              height: 39,
              margin: "0 5px",
              backgroundColor: "LightYellow",
            }}
            value={searchValue}
            onChange={(event) =>
              this.setState({ searchValue: event.target.value })
            }
          />
          <button
            className="btn btn-info"
            onClick={() => this.api_page_items(1)}
            style={{
              marginLeft: "2px",
              marginBottom: "6px",
              display: "inline-block",
            }}
          >
            <i className="fas fa-search element-hidden"></i>
            <span style={{ marginLeft: "4px" }}>查詢</span>
          </button>{" "}
          <button
            className="btn btn-info"
            onClick={this.handle_data_refresh}
            style={{
              marginLeft: "2px",
              marginBottom: "6px",
              display: "inline-block",
            }}
          >
            <i className="fas fa-sync-alt"></i>
          </button>
          <button
            className="btn btn-info"
            onClick={() => this.handle_show_ui_modal("download", {})}
            style={{ marginLeft: "2px", marginBottom: "6px" }}
          >
            <i className="fas fa-cloud-download-alt"></i>
          </button>
        </>

        <Table
          bordered
          scroll={{ y: 480 }}
          loading={loading}
          rowKey="TwId"
          dataSource={items}
          onChange={this.handle_table_change}
          pagination={{
            ...pagination,
            responsive: true,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSizeOptions: [5, 10, 20, 50, 100],
            // onChange: this.api_page_applycase,
            onShowSizeChange: this.handle_page_size_change,
          }}
          columns={this.columns}
        />
      </Card>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(StudentsNowInfoAll);
